import { SplashScreen } from "@capacitor/splash-screen";
import { Capacitor } from "@capacitor/core";

/**
 * The splash is hidden by the APP, never on a timer (`launchAutoHide` is false in
 * capacitor.config.ts). A timer either uncovers a half-painted first screen or holds a
 * static image over a ready one; both read as a slow app.
 *
 * `hideWhenReady` is called once the first route has painted — two animation frames, which
 * is after layout and after the first paint, rather than after React merely mounted.
 */
const supported = Capacitor.isNativePlatform();

export const splash = {
  hideWhenReady() {
    if (!supported) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        void SplashScreen.hide({ fadeOutDuration: 200 }).catch(() => {});
      });
    });
  },
};
